module.exports = __webpack_public_path__ + "static/media/InstaClone.f4b7aeee.png";